export default __webpack_public_path__ + "b77dac34b4eb514190ec3834eb4a60d2.svg";